export default function dispatchNavigationReady() {
  const event = new CustomEvent('navigation:ready');

  window.__NAVIGATION__READY__ = true;
  window.dispatchEvent(event);
}
